<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Kareen Lopez-Samuels hails from the small island of Jamaica and currently resides in Brampton, Ontario with her family members. A teacher of English by profession who was formally trained at The Mico University College and has been an educator for over 20 years. She is the author of <em>Zimera, They Were Here Before, Rescued from Myself and Temperate Eventually Learns a Lesson</em> (a children’s book). She lovingly refers to these as <em>The Pandemic Chronicles</em> as they were written and published between December 2019 and January 2022. The first child and only girl for her parents Winston Lopez and Beatrice Stone Lopez; although Beatrice transitioned when Kareen was only 17 years old, her teachings and way of being remain a constant source of great inspiration. She completed a BA in Linguistics from UWI (Mona, Jamaica), an MA in Language, Culture &amp; Education and an Honours Specialist in English from York University. She is currently employed to the Peel District School Board.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?fd7258ee